import { useContext } from "react";
import { Navigate } from "react-router-dom";
import currentAdminContext from "../dataManager/context/currentAdminContext";
import Base from "./Base";

const BaseSecured = ({ children }) => {
  // Get global state
  const { currentAdmin } = useContext(currentAdminContext);

  return <Base>{currentAdmin ? children : <Navigate to="/" />}</Base>;
};

export default BaseSecured;
